module.exports = __webpack_public_path__ + "assets/img/img-detail-01.77d5c255.jpg";